import React, { useEffect, useState } from "react";
import AllRoutes from "./Components/Routes/Routes";

const App = () => {
  return (
    <div>
      <AllRoutes />
    </div>
  );
};

export default App;
